export function ensureValidUrl(url: string) {
	try {
		return new URL(url).toString();
	} catch (err) {
		throw new Error(`${url} is not a valid URL`);
	}
}
